var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogContent = void 0;
var DialogContent_1 = __importDefault(require("./DialogContent"));
exports.DialogContent = DialogContent_1.default;
exports.default = DialogContent_1.default;
//# sourceMappingURL=index.js.map